import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] lg:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=moody%20dark%20editorial%20abstract%20background%2C%20deep%20charcoal%20ink%20wash%20with%20warm%20amber%20and%20crimson%20light%20streaks%2C%20folded%20newspaper%20texture%2C%20dramatic%20chiaroscuro%20lighting%2C%20cinematic%20minimal%20composition%20with%20empty%20space%20for%20headline%20text&width=1600&height=900&seq=baoliao-hero-01&orientation=landscape"
          alt="深色编辑风格的抽象背景，象征被认真对待的每一条线索"
          title="爆料投稿指南 - 微光爆料"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-transparent to-transparent"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-28 md:py-32">
        <div className="max-w-3xl">
          <span className="wei-rise inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm mb-6">
            <i className="ri-shield-check-line text-accent-300"></i>
            投稿前先看规则，避免踩坑
          </span>

          <h1 className="wei-rise font-heading font-black text-background-50 text-3xl sm:text-4xl lg:text-6xl leading-tight lg:leading-[1.1]">
            爆料投稿前
            <br />
            先搞懂这四件事
          </h1>

          <p className="wei-rise mt-6 text-background-100/90 text-base md:text-lg leading-relaxed max-w-2xl">
            投稿后多久发布、是否保护投稿人、稿费怎么结算、格式怎么写——
            <span className="text-background-50 font-medium">一次性讲清</span>
            。花三分钟看完，让你的爆料顺利过审并发布。
          </p>

          <div className="wei-rise mt-9 flex flex-col sm:flex-row gap-3">
            <a
              href="#submit"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-send-plane-fill text-lg"></i>
              立即提交爆料
            </a>
            <a
              href="#questions"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 font-medium text-sm md:text-base whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-question-line text-lg"></i>
              先看清规则
            </a>
          </div>
        </div>

        <div className="wei-rise mt-14 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
          {heroStats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-start gap-3 px-4 py-4 rounded-lg bg-background-50/8 border border-background-50/15 backdrop-blur-sm"
            >
              <span className="w-9 h-9 shrink-0 rounded-md flex items-center justify-center bg-accent-500/90 text-background-50">
                <i className={`${stat.icon} text-lg`}></i>
              </span>
              <span className="flex flex-col">
                <strong className="font-heading text-background-50 text-lg md:text-xl leading-none">
                  {stat.value}
                </strong>
                <span className="text-background-100/75 text-xs md:text-sm mt-1.5">
                  {stat.label}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}